// The issue page's held-answer bar: how many answers are waiting to go to Loom
// together, and a way to send them now.
//
// Clicks on Loom's answer (and typed Sends) on the pinned card are HELD so the
// agent is not restarted once per click — see `useAnswerHold`. A hold nobody can
// see is a send that silently did not happen, so the count is on screen, above
// the card, with the one control that ends the wait. While Loom is working the
// control is off and the bar says why: sending then would kill the turn that is
// running.

import type { JSX } from "react";

import { useT, usePlural } from "../../i18n/index.js";

export function HeldAnswersBar({
  count,
  agentBusy,
  canSend,
  onSendNow,
}: {
  readonly count: number;
  readonly agentBusy: boolean;
  readonly canSend: boolean;
  readonly onSendNow: () => void;
}): JSX.Element | null {
  const t = useT();
  const tn = usePlural();
  if (count === 0) return null;
  return (
    <div className="issue-held-bar" role="status" data-testid="held-answers-bar">
      <span className="issue-held-bar-text">{tn("plural.heldAnswers", count)}</span>
      {agentBusy && <span className="issue-held-bar-busy">{t("readiness.holdBusy")}</span>}
      <button
        type="button"
        className="btn btn-sm"
        onClick={onSendNow}
        disabled={agentBusy || !canSend}
      >
        {t("readiness.sendNow")}
      </button>
    </div>
  );
}
